import React from 'react';
import { components } from 'react-select';

export const SelectOption = ({
    innerProps,
    selectProps,
    data,
    ...props
}) => (
    <components.Option
        {...props}
        data={data}
        selectProps={selectProps}
        innerProps={{
            ...innerProps,
            'data-testid': selectProps?.testIds?.Option && `${selectProps?.testIds?.Option}-${data?.value}`,
        }}
    />
);

export const SelectOptionStyles = styles => styles;
